export default "__VITE_ASSET__LvsZlg2Y__"